import React from 'react';
import styled from 'styled-components';
import StatusWarningBordered from 'icons/status-warning-bordered';

const AlertIcon = styled(StatusWarningBordered).attrs(({ theme }) => ({
  style: {
    primaryColor: theme.colors.accentText,
  },
  size: '1.1em',
}))`
  display: inline;
  margin-right: 0.4em;
`;

const Content = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.p};
`;

const AlertContainer = styled.span<{ centered?: boolean }>`
  color: ${({ theme }) => theme.colors.accentText};
  min-height: 1.1em;
  display: inline-flex;
  align-items: center;
  justify-content: ${(props) => props.centered && 'center'};
  > * {
    display: inline;
  }
`;

interface AlertMessageProps {
  children?: React.ReactNode;
  noIcon?: boolean;
  centered?: boolean;
}

const AlertMessage = ({ children, noIcon, ...props }: AlertMessageProps): React.ReactElement => (
  <AlertContainer {...props}>
    {!!children && !noIcon && children && <AlertIcon />}
    {!!children && <Content>{children}</Content>}
  </AlertContainer>
);

export default AlertMessage;
